import { call, put, select, takeLatest } from "redux-saga/effects";
import { shortenUrlSuccess, shortenUrlFailure, SHORTEN_URL_REQUEST, ShortenUrlRequestAction } from "../action";
import { shortenUrlApi, UrlShortenerResponse } from "../api";
import { getEnableUrlShortener } from "../features";
import { getShortenedUrl } from "../api";
import { allowNumbers, allowValidUrlCharacters } from "../utils/regexUtil";

function buildLongUrl(usageId: string, partnerCode: string, sessionId?: string, rtName?: string, language?: string): string {
  const sanitizedUsageId = allowNumbers(usageId);
  if (rtName === "WLE") {
    return (
      window.location.origin +
      "/wd/f/" +
      partnerCode +
      "/" +
      sessionId +
      "/" +
      sanitizedUsageId +
      (language ? `/${language}` : "/en_US")
    );
  }
  return window.location.href.replace("/wd/l", "/wd/f");
}

export function* shortenUrlSaga(action: ShortenUrlRequestAction) {
  const { usageId, partnerCode, sessionId, rtName, language } = action.payload;
  const sanitizedUsageId = allowNumbers(usageId);
  const longUrl = allowValidUrlCharacters(buildLongUrl(usageId, partnerCode, sessionId, rtName, language));

  try {
    const enableUrlShortener: boolean = yield select(getEnableUrlShortener);

    if (enableUrlShortener) {
      const apiResponse: UrlShortenerResponse = yield call(shortenUrlApi, { partnerCode, usageId: sanitizedUsageId, url: longUrl });
      if (apiResponse?.errorMessage) {
        yield put(shortenUrlFailure(apiResponse.errorMessage, longUrl));
      } else {
        yield put(shortenUrlSuccess({ shorturl: apiResponse.shortUrl, longUrl }));
      }
    } else {
      const shorturl: string = yield call(getShortenedUrl, partnerCode, sanitizedUsageId, longUrl);
      yield put(shortenUrlSuccess({ shorturl: shorturl || longUrl, longUrl }));
    }

  } catch (error: any) {
    const errorMessage =
      error.response?.data?.errorMessage ||
      error.response?.data?.message ||
      error.message ||
      "Failed to shorten URL";

    yield put(shortenUrlFailure(errorMessage, longUrl));
  }
}

export function* watchUrlShortenerSaga() {
  yield takeLatest(SHORTEN_URL_REQUEST, shortenUrlSaga);
}
